module.exports = __webpack_public_path__ + "static/media/penguin.3d50f11.webm";


//////////////////
// WEBPACK FOOTER
// ./src/assets/penguin.webm
// module id = xMld
// module chunks = 1